import { api } from "./client";

/**
 * Per-user UI preferences — `api/me/preferences/{key}`.
 *
 * <p>A preference is an opaque JSON string the SERVER never reads: the shape is
 * the client's, keyed by a `^[a-z0-9-]{1,64}$` name, capped at 8 KB. This is
 * where a list page keeps the reader's last saved view and their column
 * choices, so they follow the person across devices rather than living in one
 * browser's `localStorage`.</p>
 *
 * <p>`get` resolves `null` when the key has never been set — that is DATA, not
 * an error, and the hook treats it as "use the fallback".</p>
 */
export const mePreferencesApi = {
  get: (key: string) => api.get<string | null>(`/me/preferences/${encodeURIComponent(key)}`),
  put: (key: string, valueJson: string) =>
    api.put<void>(`/me/preferences/${encodeURIComponent(key)}`, { valueJson }),
  remove: (key: string) => api.delete<void>(`/me/preferences/${encodeURIComponent(key)}`),
};
